import { cn } from '@/lib/utils';

interface BrandIconProps {
  className?: string;
}

export function JiraIcon({ className }: BrandIconProps) {
  return (
    <svg
      className={cn('h-5 w-5', className)}
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
    >
      <defs>
        <linearGradient id="jira-a" x1="98.031%" x2="58.888%" y1="0.161%" y2="40.766%">
          <stop offset="18%" stopColor="#0052CC" />
          <stop offset="100%" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient id="jira-b" x1="100.665%" x2="55.402%" y1="0.455%" y2="44.727%">
          <stop offset="18%" stopColor="#0052CC" />
          <stop offset="100%" stopColor="#2684FF" />
        </linearGradient>
      </defs>
      <path
        d="M244.658 0H121.707a55.502 55.502 0 0 0 55.502 55.502h22.649V77.37c.02 30.625 24.841 55.447 55.5 55.502V11.666C255.358 5.224 250.1 0 244.658 0"
        fill="#2684FF"
      />
      <path
        d="M183.822 61.262H60.872c.019 30.625 24.84 55.447 55.501 55.502h22.649v21.868c.02 30.597 24.798 55.45 55.402 55.502V72.928c0-6.442-5.258-11.666-11.602-11.666"
        fill="url(#jira-a)"
      />
      <path
        d="M122.943 122.524H0c0 30.653 24.84 55.502 55.502 55.502h22.72v21.797c.02 30.625 24.841 55.447 55.501 55.502V134.19c0-6.442-5.182-11.666-10.78-11.666"
        fill="url(#jira-b)"
      />
    </svg>
  );
}

export function LinearIcon({ className }: BrandIconProps) {
  return (
    <svg
      className={cn('h-5 w-5', className)}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        d="M1.22541 61.5228c-.97022 1.0912-.49838 2.8617.92195 3.4523C10.5765 68.855 20.4708 73 31.3326 73c21.0003 0 38.6004-15.3285 41.9455-35.5196.2122-1.278-.7935-2.3506-2.0831-2.3506H35.2593c-1.0684 0-1.9344.8659-1.9344 1.9344v7.4456c0 1.0684.866 1.9344 1.9344 1.9344h22.5637c-.4685 7.6593-4.2792 14.3792-9.9501 18.843-4.7159 3.7098-10.6698 5.9194-17.1403 5.9194-7.5563 0-14.3863-3.0531-19.3515-7.9903-1.0419-1.0359-2.7411-.9615-3.6671.1746l-5.2337 5.8863Z"
        fill="#5E6AD2"
      />
      <path
        d="M3.20356 42.1331C6.69932 22.7158 23.7789 8 44.3326 8c4.6655 0 9.1432.7434 13.3473 2.1209 1.2179.3988 1.6455 1.8972.7697 2.8602l-5.1629 5.6752c-.6846.7522-1.7965.9907-2.7498.6652C47.9879 18.4429 46.2007 18 44.3326 18c-14.8752 0-27.2098 10.8924-29.4992 25.1464-.1688 1.0516-.9786 1.8536-2.0395 1.8536H5.23752c-1.28844 0-2.29536-1.0714-2.03396-2.3406V42.1331Z"
        fill="#5E6AD2"
      />
    </svg>
  );
}

export function PeopleForceIcon({ className }: BrandIconProps) {
  return (
    <svg
      className={cn('h-5 w-5', className)}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <rect width="32" height="32" rx="7" fill="#1B8C5A" />
      <path
        d="M10.5 8h5.25c1.6 0 2.85.45 3.75 1.35.9.9 1.35 2.1 1.35 3.6 0 1.5-.45 2.7-1.35 3.6-.9.9-2.15 1.35-3.75 1.35H13.5v5.6h-3V8Zm5.05 7.2c.7 0 1.25-.2 1.65-.6.4-.4.6-.95.6-1.65s-.2-1.25-.6-1.65c-.4-.4-.95-.6-1.65-.6H13.5v4.5h2.05Z"
        fill="#fff"
      />
    </svg>
  );
}
